import React from 'react'
import shortid from 'shortid'

import { createGoogleLoginLink } from '../api-client/auth-client'
import Button from './button'
import { LoginState } from '../store/login-reducer'
import { setLocalItem } from '../local-client/local-client'

interface Props {
  login: LoginState
  state?: any
  action?: 'login' | 'register' | 'create'
}

export default function GoogleButton({
  login,
  state = shortid.generate(),
  action = 'login',
}: Props): React.ReactElement {
  const { email } = login
  return (
    <Button
      type="whiteWithBorder"
      icon="google"
      onClick={async () => {
        const nonce = shortid.generate()
        setLocalItem('ga-nonce', nonce)
        setLocalItem('ga-state', state)
        setLocalItem('ga-action', action)

        const response = await createGoogleLoginLink({
          email,
          nonce,
          state: shortid.generate(),
        })
        if (response && response.success) {
          const {
            res: { data },
          } = response
          const { authLink } = data
          window.location.assign(authLink)
        }
      }}
    >
      {action === 'login' && <>Login with your Google account</>}
      {action !== 'login' && <>Sign up with your Google account</>}
    </Button>
  )
}
